import SvgIcon from '@/assets/svgIcon';

import { useChatStore } from '../store';

interface ChildrenProps extends ParentProps {
  onCancel: (file: File) => () => void;
}

interface ParentProps {
  file: File;
}

export const FileThumbnail = ({ file }: ParentProps) => {
  const store = useChatStore();
  const handleCancel = (file: File) => () => {
    const index = store.selectedFiles.findIndex(
      (selectedFile) =>
        selectedFile.name === file.name &&
        selectedFile.lastModified === file.lastModified
    );
    if (index !== -1) store.selectedFiles.splice(index, 1);
  };
  return (
    <>
      {file.type.includes('image') ? (
        <ImageFileThumbnail onCancel={handleCancel} file={file} />
      ) : (
        <PlainFileThumbnail onCancel={handleCancel} file={file} />
      )}
    </>
  );
};

const ImageFileThumbnail = ({ file, onCancel }: ChildrenProps) => {
  const imageSource = URL.createObjectURL(file);
  return (
    <div className="relative flex h-[60px]">
      <div className="h-[60px] w-[60px] overflow-hidden rounded border-[1px] border-solid border-[#ececec]">
        <img
          className="relative h-[60px] w-[60px]"
          src={imageSource}
          alt="첨부한 이미지 썸네일"
        />
      </div>
      <button onClick={onCancel(file)} className="absolute -right-2 -top-2">
        <SvgIcon width={16} height={16} name="fileCloseIcon" />
      </button>
    </div>
  );
};

const PlainFileThumbnail = ({ file, onCancel }: ChildrenProps) => {
  return (
    <div className="relative flex h-[60px]">
      <div className="flex h-[60px] gap-1 w-[200px] rounded border-[1px] border-solid border-[#ececec] p-3">
        <SvgIcon width={36} height={36} name="pdfIcon" />
        <div className="flex flex-col items-start">
          <p className="max-w-[140px] truncate text-xs font-semibold text-black">
            {file.name}
          </p>
          <p className="text-xs font-normal text-[#3d3d3d]">{file.type}</p>
        </div>
      </div>
      <button onClick={onCancel(file)} className="absolute -right-2 -top-2">
        <SvgIcon width={16} height={16} name="fileCloseIcon" />
      </button>
    </div>
  );
};
